import { ProfOfferRoom, RentLivingTenantRequirements } from '@search/graphql-typings';

import { mapToInformations, InfoModelRaw, InformationsEnum, InformationsIconEnum, TGenerateSeoUrlParams } from './infoHelpers/types/InfoModel';
import { getFlatRoomInfo, getLivingAreaRoom, getTenantsInfoB2b, getTenantsInfoB2c } from './infoHelpers';
import { buildInfoFlat, mainBuildInfoFlat, additionalBuildInfoFlat } from './build_InfoFlat';

export function buildInfoRoom(
    room: ProfOfferRoom,
    rentTenant?: RentLivingTenantRequirements | null,
    params?: {
        isRent?: boolean;
        useB2cFuncs?: boolean;
        generateUrl?: (params: TGenerateSeoUrlParams) => string;
    },
    isMobile?: boolean
) {
    const flatInfo = room.enclosingFlat ?
        buildInfoFlat(
            room.enclosingFlat,
            undefined,
            {
                withApartment: undefined,
                useB2cFuncs: params?.useB2cFuncs,
                generateUrl: params?.generateUrl
            },
            isMobile
        ) : [];
    const roomCountInfo = getFlatRoomInfo(room);
    const roomLivingArea = getLivingAreaRoom(room);

    const informationsRaw: InfoModelRaw[] = [
        ...flatInfo
            .map(info => info.key === InformationsEnum.roomsCountInFlat ? {
                ...info,
                title: 'Комнат в квартире'
            } : info)
            .filter(info => info.key !== InformationsEnum.livingArea),
        ...(params?.useB2cFuncs ? getTenantsInfoB2c(rentTenant) : getTenantsInfoB2b(rentTenant)),
        {
            title: 'Комнат на продажу',
            value: params?.isRent ? null : roomCountInfo,
            key: InformationsEnum.roomCountInfo,
            icon: InformationsIconEnum.flat
        },
        {
            title: 'Площадь комнат',
            value: roomLivingArea,
            key: InformationsEnum.roomLivingArea,
            icon: InformationsIconEnum.tertiaryArea
        }
    ];

    return mapToInformations(informationsRaw, params);
}

export function buildMainInfoRoom(
    room: ProfOfferRoom,
    rentTenant?: RentLivingTenantRequirements | null,
    params?: {
        isRent?: boolean;
        useB2cFuncs?: boolean;
        generateUrl?: (params: TGenerateSeoUrlParams) => string;
    },
    isMobile?: boolean
) {
    const roomCountInfo = getFlatRoomInfo(room);
    const param = isMobile ? [ 'Этаж' ] : [ 'Этаж', 'Площадь квартиры' ];
    const flatInfo = room.enclosingFlat ?
        mainBuildInfoFlat(
            room.enclosingFlat,
            undefined,
            {
                withApartment: undefined,
                useB2cFuncs: params?.useB2cFuncs,
                generateUrl: params?.generateUrl
            },
            isMobile
        ).filter(item => param.includes(item.title)) : [];
    const roomLivingArea = getLivingAreaRoom(room);

    const infoRaw: InfoModelRaw[] = isMobile ? [
        ...flatInfo
            .map(info => info.key === InformationsEnum.roomsCountInFlat ? {
                ...info,
                title: 'Комнат в квартире'
            } : info)
            .filter(info => info.key !== InformationsEnum.livingArea),
        ...(params?.useB2cFuncs ? getTenantsInfoB2c(rentTenant) : getTenantsInfoB2b(rentTenant)),
        ...(roomCountInfo ? [ {
            title: 'В продаже',
            // eslint-disable-next-line no-nested-ternary
            value: params?.isRent ? null :
                (Number(roomCountInfo) > 1 ? `${roomCountInfo} комнаты` : `${roomCountInfo} комната`),
            key: InformationsEnum.roomCountInfo,
            icon: InformationsIconEnum.flat
        } ] : []),
        {
            title: 'Площадь комнат',
            value: roomLivingArea,
            key: InformationsEnum.roomLivingArea,
            icon: InformationsIconEnum.tertiaryArea
        },
    ] : [
        ...flatInfo
            .map(info => info.key === InformationsEnum.roomsCountInFlat ? {
                ...info,
                title: 'Комнатность'
            } : info)
            .filter(info => info.key !== InformationsEnum.livingArea),
        ...(params?.useB2cFuncs ? getTenantsInfoB2c(rentTenant) : getTenantsInfoB2b(rentTenant)),
        {
            title: 'Площадь комнат',
            value: roomLivingArea,
            key: InformationsEnum.roomLivingArea,
            icon: InformationsIconEnum.tertiaryArea
        },
        ...(roomCountInfo ? [ {
            title: 'В продаже',
            // eslint-disable-next-line no-nested-ternary
            value: params?.isRent ? null :
                (Number(roomCountInfo) > 1 ? `${roomCountInfo} комнаты` : `${roomCountInfo} комната`),
            key: InformationsEnum.roomCountInfo,
            icon: InformationsIconEnum.flat
        } ] : []),
    ];

    return mapToInformations(infoRaw, params);
}

export function buildAdditionalInfoRoom(
    room: ProfOfferRoom,
    rentTenant?: RentLivingTenantRequirements | null,
    params?: {
        isRent?: boolean;
        useB2cFuncs?: boolean;
        generateUrl?: (params: TGenerateSeoUrlParams) => string;
    }
) {
    const roomCountInfo = getFlatRoomInfo(room);
    const flatInfo = room.enclosingFlat ?
        additionalBuildInfoFlat(
            room.enclosingFlat,
            undefined,
            {
                withApartment: undefined,
                useB2cFuncs: params?.useB2cFuncs,
                generateUrl: params?.generateUrl
            }
        ) : [];

    const infoRaw: InfoModelRaw[] = [
        ...flatInfo
            .map(info => info.key === InformationsEnum.roomsCountInFlat ? {
                ...info,
                title: 'Комнат в квартире'
            } : info)
            .filter(info => info.key !== InformationsEnum.livingArea),
        ...(params?.useB2cFuncs ? getTenantsInfoB2c(rentTenant) : getTenantsInfoB2b(rentTenant)),
        {
            title: 'Комнат на продажу',
            value: params?.isRent ? null : roomCountInfo,
            key: InformationsEnum.roomCountInfo,
            icon: InformationsIconEnum.flat
        },
    ];

    return mapToInformations(infoRaw, params);
}

